import React from "react";
import Spinner from "react-bootstrap/Spinner";

/******************* 
@Purpose : Used for loader view
@Parameter : {}
@Author : INIC
******************/
function Loader() {
  return (
    <span
      style={{
        textAlign: "center",
        position: "absolute",
        top: "50%",
        bottom: "50%",
        left: "50%",
        zIndex: "999",
      }}
    >
      <Spinner animation="border" variant="primary" className="p-5" />
    </span>
  );
}
export default Loader;
